<div class="mb-1 d-flex justify-content-between align-items-center">
  <h5 class="pr-1 form-control-label text-break"
      [ngClass]="{ 'required-field-label': required }">{{ getTitle() }} </h5>
  <input *ngIf="copyVisible" type="button" class="btn btn-secondary cursor-pointer" (click)="openCopyDialog()"
         value="{{'FORM_RECORD_INVOICE_FIELD_COPY'|translate}}"/>
  <input *ngIf="importVisible" type="button" class="btn btn-secondary cursor-pointer" (click)="openParseDialog()"
         value="{{'FORM_RECORD_STOCK_PARSE_XLS'|translate}}"/>

</div>
<label class="warning-text"
       *ngIf="hasDisabledItem && !nonEditable">{{ 'FORM_RECORD_STOCK_DISABLED_WARNING_TEXT' | translate }}</label>
<label class="warning-text"
       *ngIf="!optionalValue && htmlForm && htmlForm.getForm().submitted && (!model.stocks || model.stocks.length === 0)">{{ 'FORM_RECORD_STOCK_REQUIRED_WARNING_TEXT' | translate }}</label>
<div class="mb-1 d-flex align-items-center justify-content-between" *ngIf="isAnyPriceChanged() && !nonEditable && rightModel.stockItemPricesRead.hasRight()">
  <label class="warning-text">{{ 'FORM_RECORD_STOCK_PRICES_CHANGED_WARNING_TEXT' | translate }}</label>
  <button type="button" class="btn btn-primary"
          (click)="acceptAllNewPrices()">{{ 'FORM_RECORD_STOCK_REFRESH_PRICE_ALL_TEXT' | translate }}
  </button>
</div>
<div class="mb-1 d-flex align-items-center justify-content-between"
     *ngIf="shouldDisplayDispersionPercentValidationMessage() && !nonEditable">
  <label class="warning-text">{{ 'FORM_RECORD_STOCK_DISPERSION_PERCENT_ERROR' | translate }}</label>
</div>
<div *ngIf="model.stocks && currencies">
  <table class="table table-sm invoice-create-table">
    <thead>

    <tr>
      <th class="responsive-table-column min-w-15">{{ 'COMMON_NAME' | translate }}<br/>
        <span class="text-muted">{{ 'FORM_RECORD_STOCK_STOCK_NAME' | translate }}</span>
        <div *ngIf="hasAnyInvoicedItem()" class="text-muted">{{ 'INVOICES_TABLE_HEADER_INVOICE_NUMBER' | translate }}
        </div>
      </th>
      <th class="responsive-table-column hidden-lg-down">{{ 'STOCK_ITEM_TABLE_HEADER_PRODUCT_CODE' | translate }}
        <br/><span class="text-muted">{{ 'COMMON_EXTERNAL_ID_SHORT' | translate }}</span></th>
      <th *ngIf="!dispersionPercentEnabled"
          class="responsive-table-column min-w-20">{{ 'FORM_RECORD_STOCK_AMOUNT' | translate }}
      </th>
      <th *ngIf="!dispersionPercentEnabled"
          class="fit hidden-lg-down">{{ 'FORM_RECORD_STOCK_IN_STOCK_AMOUNT' | translate }}
      </th>
      <th *ngIf="dispersionPercentEnabled"
          class="responsive-table-column">{{ 'FORM_RECORD_STOCK_DISPERSION_PERCENT' | translate }}
      </th>
      <th class="responsive-table-column hidden-md-down min-w-10"
          style="overflow:visible"
          *ngIf="ledgerNumberEnabled"><span>{{ 'FORM_RECORD_STOCK_LEDGER_NUMBER' | translate }}</span>
        <angular2-multiselect
          *ngIf="!nonEditable"
          class="form-control"
          [(ngModel)]="mainLedgerNumber"
          [data]="ledgerNumbers"
          [settings]="remoteDropdownSettings"
          name="mainledgerNumberInput"
          id="mainledgerNumberInput"
          #mainledgerNumberInput="ngModel"
          (onRemoteSearch)="onLedgerNumberSearch($event.target.value)"
          (onSelect)="onMainLedgerNumberSelected($event)"
          validateEnabledItems>
        </angular2-multiselect>
      </th>
      <th class="responsive-table-column text-break" *ngIf="rightModel.stockItemPricesRead.hasRight()">{{ 'FORM_RECORD_STOCK_UNIT_PRICE' | translate }}
        <br/><span
          class="text-muted">{{ 'STOCK_ITEM_WEIGHT' | translate }}</span>
      </th>
      <th class="responsive-table-column hidden-md-down" *ngIf="rightModel.stockItemPricesRead.hasRight()">{{ 'FORM_RECORD_STOCK_SUM_LINE_GROSS_PRICE' | translate }}<br/><span
        class="text-muted">{{ 'FORM_RECORD_STOCK_SUM_LINE_NET_PRICE' | translate }}</span></th>
      <th class="w-table-options-menu text-center" *ngIf="!nonEditable && model.stocks.length > 0"
          (click)="removeAllRecords()">
        <i class="icomoon icomoon-trash cursor-pointer icon-medium"></i>
      </th>
    </tr>
    </thead>
    <tbody *ngIf="model.stocks && model.stocks.length > 0">
    <ng-container *ngFor="let item of model.stocks; index as i;">
      <tr [ngClass]="{'disabled-item': item.disabledItem && !nonEditable}">
        <td class="responsive-table-column align-middle">
          <div class="d-flex align-items-center">
            <div class="stock-item-image-container"
                 [popover]="infoPopover"
                 [outsideClick]="true"
                 placement="right">
              <div *ngIf="item.stockRecord.stockItem.picture && item.stockRecord.stockItem.picture.image_loaded"
                   class="stock-item-image"
                   [style.background-image]="item.stockRecord.stockItem.picture!.picture_src"></div>
              <div *ngIf="!item.stockRecord.stockItem.picture || !item.stockRecord.stockItem.picture.image_loaded"
                   class="stock-item-image-placeholder">
                <div class="icon-background"></div>
                <i *ngIf="item.stockRecord.stockItem.type === 'STOCK'"
                   class="icon-centered icomoon icomoon-products"></i>
                <i *ngIf="item.stockRecord.stockItem.type === 'SERVICE'"
                   class="icon-centered icomoon icomoon-sidebar-customers"></i>
              </div>
              <ng-template #infoPopover>
                <div class="record-info-name">{{ item.stockRecord.stockItem.name }}</div>
                <div class="record-info-external-id">{{ item.stockRecord.stockItem.external_id }}</div>
                <div class="record-info-price" *ngIf="rightModel.stockItemPricesRead.hasRight() && item.stockRecord.stockItem.unit_price">
                  {{ 'STOCK_RECORD_SELECTOR_DIALOG_RECORD_PRICE' | translate }} {{ item.stockRecord.stockItem.unit_price.value | formattedNumber:true:2 }} {{ getCurrencyString(item.stockRecord.stockItem.unit_price.currency_code) }}
                </div>
                <div class="record-info-container">
                  <span class="record-info-label">{{ 'STOCK_RECORD_SELECTOR_DIALOG_STOCK_NAME' | translate }}</span>
                  <span class="record-info-description">{{ item.stockRecord.stockName }}</span>
                </div>
                <div class="record-info-container">
                  <span class="record-info-label">{{ 'STOCK_RECORD_SELECTOR_DIALOG_RECORD_AMOUNT' | translate }}</span>
                  <span
                    class="record-info-description">{{ item.stockRecord.amount | formattedNumber }} {{ item.stockRecord.stockItem.unit }}</span>
                  <span *ngIf="item.stockRecord.stockItem.package_data"
                        class="table-text-subtitle">{{ StockItemUtils.convertToPackageStr(item.stockRecord.amount, item.stockRecord.stockItem.package_data) }}</span>
                </div>
                <div class="record-info-container">
                  <span
                    class="record-info-label">{{ 'STOCK_RECORD_SELECTOR_DIALOG_RECORD_VAT_RATE' | translate }}</span>
                  <span class="record-info-description" *ngIf="rightModel.stockItemPricesRead.hasRight() && item.stockRecord.stockItem.unit_price">{{ item.stockRecord.stockItem.unit_price.vat_rate }}%</span>
                </div>
                <div class="record-info-container" *ngIf="item.stockRecord.stockItem.product_code">
                  <span
                    class="record-info-label">{{ 'STOCK_RECORD_SELECTOR_DIALOG_RECORD_PRODUCT_CODE' | translate }}</span>
                  <span class="record-info-description">{{ item.stockRecord.stockItem.product_code }}</span>
                </div>
                <div class="record-info-container" *ngIf="item.stockRecord.stockItem.hun_vtsz_number">
                  <span
                    class="record-info-label">{{ 'STOCK_RECORD_SELECTOR_DIALOG_RECORD_HUN_VTSZ_NUMBER' | translate }}</span>
                  <span class="record-info-description">{{ item.stockRecord.stockItem.hun_vtsz_number }}</span>
                </div>
                <div class="record-info-container" *ngIf="item.stockRecord.stockItem.weight_string">
                  <span class="record-info-label">{{ 'STOCK_RECORD_SELECTOR_DIALOG_RECORD_WEIGHT' | translate }}:</span>
                  <span class="record-info-description">{{ item.stockRecord.stockItem.weight_string }}</span>
                </div>
                <div class="record-info-container" *ngIf="rightModel.stockItemPricesRead.hasRight() && item.stockRecord.intakeNetPriceLatest">
                  <span class="record-info-label">{{ 'STOCK_RECORD_LOT_INTAKE_PRICE_LATEST' | translate }}:</span>
                  <span
                    class="record-info-description" *ngIf="rightModel.stockItemPricesRead.hasRight() && item.stockRecord.stockItem.unit_price">{{ item.stockRecord.intakeNetPriceLatest | formattedNumber:true:6 }} {{ getCurrencyString(item.stockRecord.stockItem.unit_price.currency_code) }}</span>
                </div>
                <div class="record-info-description" *ngIf="item.stockRecord.stockItem.description">
                  <span [innerHTML]="item.stockRecord.stockItem.description"></span>
                </div>
              </ng-template>
            </div>
            <div class="text-truncate">
              <a class="stock-item-name cursor-pointer"
                 uiSref="Admin.StockItemDetail"
                 [uiParams]="{ id: item.stockRecord.stockItem.id }">
                {{ item.stockRecord.stockItem.name }}</a>
              <p class="text-muted text-truncate mb-0">{{ item.stockRecord.stockName }}</p>
              <app-table-badge
                *ngIf="item.invoiced"
                [badgeStyle]="BadgeStyle.SECONDARY"
                [iconClass]="'icomoon-invoice'"
                [text]="item.invoiceNumber">
              </app-table-badge>
            </div>
          </div>
        </td>
        <td class="responsive-table-column align-middle hidden-lg-down">
          {{ item.stockRecord.stockItem.product_code }}<br/>
          <span class="text-muted text-truncate mb-0">{{ item.stockRecord.stockItem.external_id }}</span>
        </td>
        <td *ngIf="!nonEditable && !item.invoiced && !dispersionPercentEnabled"
            class="responsive-table-column align-middle"
            style="overflow:visible"
            [ngClass]="{ 'has-danger': (!item.validAmount && !item.service) || !item.amount || !item.selectedUnitOfMeasure}">
          <div class="d-flex flex-wrap align-items-center">
            <div class=" col-xl-4 col-lg-5 col-md-5 col-sm-5 col-12 p-0">
              <input type="text" min="0" class="form-control"
                     placeholder="{{item.stockRecord.stockItem.unit}}"
                     [textMask]="{mask: InputMask.NATURAL_FLOAT_6, guide: false}"
                     [(ngModel)]="item.numberAmount"
                     (change)="notifyStockRecordAmountChange(item)"
                     [ngClass]="{ 'form-control-danger': (!item.validAmount && !item.service) || !item.amount }"
                     [disabled]="item.disabledItem">
            </div>
            <div class="col-xl-8 col-lg-7 col-md-7 col-sm-7 col-12 p-0">
              <angular2-multiselect
                class="form-control"
                [(ngModel)]="item.unitOfMeasure"
                [data]="item.stockRecord.stockItem.measurements"
                [settings]="dropdownSettings"
                name="unitOfMeasureInput"
                id="unitOfMeasureInput"
                (onDeSelect)="notifyStockRecordAmountChange(item)"
                (onSelect)="notifyStockRecordAmountChange(item)"
                [ngClass]="{ 'form-control-danger': (!item.validAmount && !item.service) || !item.selectedUnitOfMeasure }"
                #unitOfMeasureInput="ngModel"
                [readonly]="item.disabledItem"
                validateEnabledItems
                required>
              </angular2-multiselect>
            </div>
          </div>
          <div *ngIf="item.stockRecord.stockItem.package_data && item.isBaseUnitSelected()"
               class="table-text-subtitle">{{ StockItemUtils.convertToPackageStr(item.numberAmount, item.stockRecord.stockItem.package_data) }}
          </div>
          <div *ngIf="!item.isBaseUnitSelected()"
               class="table-text-subtitle">{{ StockItemUtils.convertToBaseStr(item.numberAmount, item.selectedUnitOfMeasure, item.stockRecord.stockItem.baseUnit.unit_name) }}
          </div>
        </td>
        <td *ngIf="!nonEditable && !item.invoiced && dispersionPercentEnabled"
            class="fit align-middle"
            [ngClass]="{ 'has-danger': !item.validDispersionPercent || item.dispersionPercent === undefined }">
          <div class="d-flex align-items-center">
            <input type="number" min="0" class="form-control percentage-field"
                   placeholder="{{'FORM_RECORD_STOCK_DISPERSION_PERCENT' | translate}}"
                   [(ngModel)]="item.dispersionPercent"
                   (blur)="onDispersionPercentChanged(item)"
                   [ngClass]="{ 'form-control-danger': !item.validDispersionPercent || item.dispersionPercent === undefined }"
                   [disabled]="item.disabledItem">
            <span class="ml-05">%</span>
          </div>
        </td>
        <td *ngIf="(nonEditable || item.invoiced) && !dispersionPercentEnabled"
            class="responsive-table-column align-middle">{{ item.amount | formattedNumber }} {{ item.selectedUnitOfMeasure.unit_name }}
          <div *ngIf="item.stockRecord.stockItem.package_data && item.isBaseUnitSelected()"
               class="table-text-subtitle">{{ StockItemUtils.convertToPackageStr(item.numberAmount, item.stockRecord.stockItem.package_data) }}
          </div>
          <div *ngIf="!item.isBaseUnitSelected()"
               class="table-text-subtitle">{{ StockItemUtils.convertToBaseStr(item.numberAmount, item.selectedUnitOfMeasure, item.stockRecord.stockItem.baseUnit.unit_name) }}
          </div>
        </td>
        <td *ngIf="(nonEditable || item.invoiced) && dispersionPercentEnabled"
            class="responsive-table-column align-middle">{{ item.dispersionPercent }}%
        </td>
        <td *ngIf="!dispersionPercentEnabled"
            class="align-middle hidden-lg-down fit font-xs">{{ item.stockRecord.amount | formattedNumber }} {{ item.stockRecord.stockItem.unit }}
          <div *ngIf="item.stockRecord.stockItem.package_data"
               class="table-text-subtitle">{{ StockItemUtils.convertToPackageStr(item.stockRecord.amount, item.stockRecord.stockItem.package_data) }}
          </div>
        </td>
        <td class="responsive-table-column align-middle hidden-md-down"
            style="overflow:visible"
            [ngClass]="{ 'has-danger': !ledgerNumberInput.valid}"
            *ngIf="ledgerNumberEnabled">
          <angular2-multiselect
            class="form-control"
            [(ngModel)]="item.ledgerNumber"
            [data]="ledgerNumbers"
            [settings]="remoteDropdownSettings"
            name="ledgerNumberInput"
            id="ledgerNumberInput"
            #ledgerNumberInput="ngModel"
            (onRemoteSearch)="onLedgerNumberSearch($event.target.value)"
            [readonly]="nonEditable || item.disabledItem"
            [required]="ledgerNumberRequired"
            [ngClass]="{ 'form-control-danger': !ledgerNumberInput.valid }"
            validateEnabledItems>
          </angular2-multiselect>
        </td>
        <td class="responsive-table-column align-middle" *ngIf="rightModel.stockItemPricesRead.hasRight() && item.stockRecord.stockItem.unit_price">
          {{ getReducedNetPrice(item) | formattedNumber }} {{ getCurrencyString(item.stockRecord.stockItem.unit_price.currency_code) }}
          <ng-container *ngIf="model.discountPercent === null && !dispersionPercentEnabled">
            <i class="icomoon icomoon-price icon-standard price-edit-icon cursor-pointer"
               [popover]="customPricePopover" triggers="click" container="body"
               #customPricePopoverTrigger="bs-popover"></i>
            <ng-template #customPricePopover>
              <app-form-record-stock-item-custom-price-edit
                class="pointer-events-auto"
                [discount]="model.discountPercent"
                (onPriceChanged)="onCustomPriceChanged(customPricePopoverTrigger)"
                (onCloseButtonClicked)="customPricePopoverTrigger.hide()"
                [disabled]="nonEditable || item.invoiced || item.disabledItem"
                [currencyCodeString]="getCurrencyString(item.stockRecord.stockItem.unit_price.currency_code)"
                [model]="item">
              </app-form-record-stock-item-custom-price-edit>
            </ng-template>
          </ng-container>
          <i *ngIf="isPriceChanged(item) && !nonEditable && !item.invoiced"
             (click)="acceptNewPrice(item)"
             title="{{'FORM_RECORD_STOCK_REFRESH_PRICE_TEXT' | translate}}"
             class="icomoon icomoon-restart icon-standard px-quarter cursor-pointer warning-text">
          </i>
          <div>
          <span class="text-muted font-xs" *ngIf="+getReducedNetPrice(item) !== +getUnitPrice(item)">
          <span>{{ 'FORM_RECORD_STOCK_ORIGINAL_PRICE' | translate }}</span>:
          <span
            class="text-truncate font-weight-bold">
            {{ getUnitPrice(item).toFixed(2) | formattedNumber }} {{ getCurrencyString(item.stockRecord.stockItem.unit_price.currency_code) }}
          </span>
        </span>
          </div>
          <div class="text-muted text-truncate mb-0">{{ item.sumWeight }}</div>
        </td>
        <td class="responsive-table-column align-middle hidden-md-down" *ngIf="rightModel.stockItemPricesRead.hasRight() && item.stockRecord.stockItem.unit_price">{{ getRecordGrossPrice(item) | formattedNumber }}
          {{ getCurrencyString(item.stockRecord.stockItem.unit_price.currency_code) }}
          <div class="text-muted font-xs"
               *ngIf="getRecordCustomGrossPrice(item) && +getRecordDefaultGrossPrice(item) !== +getRecordCustomGrossPrice(item)">
            <span>{{ 'FORM_RECORD_STOCK_DISCOUNT' | translate }}</span>
            <span
              class="text-truncate font-weight-bold">
            {{ (+getRecordDefaultGrossPrice(item) - +getRecordCustomGrossPrice(item)).toFixed(2) | formattedNumber }} {{ getCurrencyString(item.stockRecord.stockItem.unit_price.currency_code) }}
          </span>
          </div>
          <div
            class="text-muted">{{ getRecordNetPrice(item) | formattedNumber }} {{ getCurrencyString(item.stockRecord.stockItem.unit_price.currency_code) }}
          </div>

        </td>
        <td class="responsive-table-column align-middle text-center hidden-lg-up" (click)="toggleEdit(i)"
            *ngIf="!nonEditable && !item.invoiced"><i
          class="icomoon icomoon-modify cursor-pointer icon-medium"></i></td>
        <td class="responsive-table-column align-middle text-center hidden-md-down" (click)="removeRecord(i)"
            *ngIf="!nonEditable && !item.invoiced"><i
          class="icomoon icomoon-trash cursor-pointer icon-medium"></i></td>
      </tr>
      <tr *ngIf="commentEnabled" [ngClass]="{'disabled-item': item.disabledItem && !nonEditable}">
        <td *ngIf="!nonEditable"
            [ngClass]="{ 'has-danger': commentRequired && (item.comment === undefined || item.comment.length === 0)}"
            colspan="100%">
          <app-form-record-stock-field-comment-edit
            [(commentText)]="item.comment"
            [required]="commentRequired"
            [customLabel]="commentCustomLabel"
            [disabled]="item.disabledItem"
          ></app-form-record-stock-field-comment-edit>
        </td>

        <td *ngIf="nonEditable" colspan="100%">
          <p class="text-muted text-truncate mb-0">{{ item.comment }}</p>
        </td>
      </tr>
      <tr *ngIf="item.editing">
        <td colspan="100%" style="padding: 0">
          <app-form-record-stock-field-item-edit
            [fieldId]="fieldId"
            [model]="item"
            [discount]="model.discountPercent"
            [excludedIds]="excludedIds"
            [uniqueStockRecords]="uniqueStockRecords"
            [usableCategoryIds]="usableCategoryIds"
            [customerRecordId]="customerRecordId"
            [dispersionPercentEnabled]="dispersionPercentEnabled"
            [dispersionPercentValidator]="dispersionPercentValidator"
            (dispersionPercentChangedEvent)="onDispersionPercentChangedInEditor($event)"
            (remove)="removeRecord(i)"
            (cancel)="closeRow(i)"
            (save)="saveRecord(i, $event)">
          </app-form-record-stock-field-item-edit>
        </td>
      </tr>
    </ng-container>
    </tbody>
    <tbody *ngIf="!model.stocks || model.stocks.length === 0">
    <tr>
      <td colspan="9">
        <div class="text-center text-muted p-2">
          <label class="m-0" *ngIf="!nonEditable">{{ 'FORM_RECORD_STOCK_NO_ITEM' | translate }}</label>
          <label class="m-0" *ngIf="nonEditable">{{ 'FORM_RECORD_STOCK_NO_ITEM_READONLY' | translate }}</label>
        </div>
      </td>
    </tr>
    </tbody>
  </table>
  <button type="button" class="btn btn-secondary-green"
          *ngIf="!nonEditable"
          (click)="openStockRecordSelectorDialog()">
    {{ 'FORM_RECORD_STOCK_ADD' | translate }}
  </button>

  <div>
    <div class="d-flex justify-content-end" *ngIf="model.discountPercent !== undefined && !dispersionPercentEnabled">
      <div class="d-flex align-items-center">
        <label class="mr-1 mb-0">{{ 'FORM_RECORD_STOCK_DISCOUNT' | translate }}</label>
        <select class="form-control min-width-7-5" [compareWith]="SelectUtils.compareNumbersWithNull"
                [(ngModel)]="model.discountPercent" *ngIf="!nonEditable"
                (ngModelChange)="resetCustomPrices()" id="discountSelect" name="discountSelect"
                #discountSelect="ngModel">
          <option *ngFor="let item of availableDiscountsForDropdown" [ngValue]="item.id">{{ item.text }}</option>
        </select>
        <label class="mb-0">{{ readonlyDiscount }}</label>
      </div>
      <!-- /.row -->
    </div>
    <!-- /.row -->
    <div class="row mt-1" *ngIf="rightModel.stockItemPricesRead.hasRight() && sameCurrency">
      <div class="col-md-4 offset-md-8">
        <div class="d-flex justify-content-between pt-1 mb-1 border-top">
          <div class="font-weight-bold text-small">{{ 'FORM_RECORD_STOCK_SUM_NET_PRICE' | translate }}</div>
          <div>{{ netSumPrice | formattedNumber }} {{ getCurrencyCode() }}</div>
        </div>
        <div class="d-flex justify-content-between">
          <div class="font-weight-bold text-small">{{ 'FORM_RECORD_STOCK_SUM_GROSS_PRICE' | translate }}</div>
          <div>{{ grossSumPrice | formattedNumber }} {{ getCurrencyCode() }}</div>
        </div>
      </div>
    </div>
    <div class="pull-right mb-1" *ngIf="!sameCurrency"><h6
      class="text-muted">{{ 'FORM_RECORD_STOCK_CURRENCY_ERROR' | translate }}</h6></div>
    <div class="row mt-1" *ngIf="sumWeight.length > 0">
      <div class="col-md-4 offset-md-8">
        <div class="d-flex justify-content-between">
          <div class="font-weight-bold text-small">{{ 'FORM_RECORD_STOCK_SUM_WEIGHT' | translate }}</div>
          <div>{{ sumWeight }}</div>
        </div>
      </div>
    </div>
    <div class="row mt-1" *ngIf="sumBaseAmount.length > 0">
      <div class="col-md-4 offset-md-8">
        <div class="d-flex justify-content-between">
          <div class="font-weight-bold text-small">{{ 'FORM_RECORD_STOCK_SUM_BASE_AMOUNT' | translate }}</div>
          <div>{{ sumBaseAmount }}</div>
        </div>
      </div>
    </div>
    <!-- /.pull-right -->
  </div>
</div>

